'use client';

import Grid2 from '@mui/material/Unstable_Grid2';

import ChipBusinessTripFormStatus from '@/components/chip/ChipBusinessTripFormStatus';
import TextAction from '@/components/text-action/TextAction';
import { DisplayField } from '@/components/typography/DisplayField';
import type { BusinessTripFormResponse } from '@/types/apps/business-trip-form.type';
import type { StatusBusinessTripFormEnum } from '@/types/enums/business-trip-form-status.enum';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';
import { useTheme } from '@mui/material/styles';

interface BusinessTripFormInfoProps {
    data: BusinessTripFormResponse | null;
}

const BusinessTripFormInfo: React.FC<BusinessTripFormInfoProps> = ({
    data,
}) => {
    const theme = useTheme();

    return (
        <Grid2 container spacing={6}>
            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.code} copy>
                        {t('Mã phiếu')}
                    </TextAction>
                }
                value={data?.code}
            />
            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.customer?.name} copy>
                        {t('Khách hàng')}
                    </TextAction>
                }
                value={data?.customer?.name}
            />
            <DisplayField
                xs={4}
                label='Kỹ thuật viên'
                value={data?.technical?.fullname}
            />
            <DisplayField
                xs={4}
                label='Thời gian check-in (Dự kiến)'
                value={dateUtils.getDateTimeLocal(data?.checkinPlan)}
            />
            <DisplayField
                xs={4}
                label='Thời gian check-out (Dự kiến)'
                value={dateUtils.getDateTimeLocal(data?.checkoutPlan)}
            />
            <DisplayField
                xs={4}
                label='Số giờ thực hiện'
                value={data?.totalHour}
            />
            <DisplayField xs={4} label='Mô tả' value={data?.description} />
            {data?.checkin && (
                <>
                    <DisplayField
                        xs={4}
                        label='Trạng thái công tác'
                        value={
                            <ChipBusinessTripFormStatus
                                size='small'
                                status={
                                    (data?.status as StatusBusinessTripFormEnum) ||
                                    '-:-'
                                }
                                theme={theme}
                            />
                        }
                    />
                    <DisplayField
                        xs={4}
                        label='Thời gian check-in (Thực tế)'
                        value={
                            data?.checkin
                                ? dateUtils.getDateTime(data?.checkin)
                                : '-:-'
                        }
                    />

                    <DisplayField
                        xs={4}
                        label='Thời gian check-out (Thực tế)'
                        value={
                            data?.checkout
                                ? dateUtils.getDateTime(data?.checkout)
                                : '-:-'
                        }
                    />
                    <DisplayField
                        xs={4}
                        label='Trạng thái vị trí'
                        value={
                            data?.isCorrectLocation
                                ? t('Đúng vị trí')
                                : t('Sai vị trí')
                        }
                    />
                </>
            )}
        </Grid2>
    );
};

export default BusinessTripFormInfo;
